import { Td, Tooltip, Tr } from "@chakra-ui/react";
import MenuRUD from "components/Menu/MenuRUD";
import React, { useContext, useState } from "react";
import styled from "styled-components/macro";
import { IconGeneric } from "styled/Icons.styled";
import { BsCheckCircleFill } from "react-icons/bs";
import { __ShowDepartments } from "request/configuration/__Localitation";
import { useSelector } from "react-redux";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import environment from "constants/apiConst";
import { ConfigIconStatus } from "pages/Configuration/tables/components/LoadingConfig";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;

const TBodyDeparta = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const { setUpdate, update, setLoading } = useContext(
    ConfigurationCRUDContext
  );
  const [openAlert] = AlertErrorAlert();
  const [loadingIcons, setLoadingIcons] = useState(false);

  const desactivarAndActivar = async (result) => {
    setLoadingIcons(true);
    setLoading(true);
    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(token, environment.DEPARTMENTS_INACTIVE, data.id)
          : await __ACTIVAR(token, environment.DEPARTMENTS_ACTIVE, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingIcons(false);
      setLoading(false);
    }
  };

  const handleState = async () => {
    try {
      const res = await __ShowDepartments(token, data.id);
      const result = res.data.status.data.status_department;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data.code_department}</Td>
      <Td className="text-center">{data.name_department} </Td>

      <Tooltip
        placement="top"
        hasArrow
        label={data.status_department === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={handleState}
          className="text-center"
          isNumeric
          text={data.status_department}
        >
          <ConfigIconStatus
            loading={loadingIcons}
            status={data?.status_department}
          />
        </TdState>
      </Tooltip>
      <Td isNumeric className="text-center">
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TBodyDeparta;
